// extracted by mini-css-extract-plugin
export const wrapper = "bookbox-module--wrapper--MiffY";
export const card = "bookbox-module--card--lWPJq";
export const descriptions = "bookbox-module--descriptions--M9VUV";
export const button4 = "bookbox-module--button4--2lpwg";
export const btn4 = "bookbox-module--btn4--2TEmW";
export const back = "bookbox-module--back--1gC2m";